
export interface IMapLocation {
    center: [number, number]
    mapId?: number;
    zoom: number
};

export const parseMapLocation = (value: string): IMapLocation | undefined => {
    try {
        let almostJson = value
            .replace(/\)\(/g, ',"')
            .replace(/=/g, '":')
            .replace(/\(/g, '{"')
            .replace(/\)/g, "}")
            // add double quotes tilannekuva id as string
            .replace(/"tk":/, '"tk":"')
            .replace(/,"x"/, '","x"')
        const { x, y, tk, z } = JSON.parse(almostJson);
        return {
            mapId: tk,
            center: [x, y],
            zoom: z
        }
    } catch (err) {
        console.error("parseMapLocation: value is not in valid format.");
    }
};

export const encodeMapLocation = (data: IMapLocation) => {
    let location = [];

    if (data.mapId) {
        location.push(`(tk=${data.mapId})`);
    };

    location.push(`(x=${data.center[0]})`);
    location.push(`(y=${data.center[1]})`);
    location.push(`(z=${data.zoom})`);

    return location.join("");
};

